import { apiGet, apiPatch, apiPost } from "./axiosClient";

export interface AuthMe {
  id: string;
  keycloakId: string;
  email: string;
  phone?: string;
  role: "PATIENT" | "DOCTOR" | "ADMIN";
  status: "ACTIVE" | "SUSPENDED" | "PENDING_VERIFICATION";
}

export const syncUser = () => apiPost<AuthMe>("/api/auth/sync");
export const getMe = () => apiGet<AuthMe>("/api/auth/me");
export const updatePhone = (phone: string) =>
  apiPatch<AuthMe>("/api/auth/me/phone", { phone });

/**
 * Promotes the authenticated user (default ROLE_PATIENT on Keycloak signup)
 * into a doctor account. Assigns ROLE_DOCTOR realm role + sets local status
 * to PENDING_VERIFICATION. The SPA must force a token refresh after this
 * call so the new JWT carries ROLE_DOCTOR.
 */
export const signupAsDoctor = () => apiPost<AuthMe>("/api/auth/doctor/signup");

/** Public. Signed-in calls send the account email from the token. */
export const requestAccountDeletion = (body: {
  email?: string;
  note?: string;
  source?: "WEB" | "ANDROID";
  company?: string;
}) => apiPost<{ status: string }>("/api/auth/account-deletion-requests", body);

export interface DoctorVerification {
  id: string;
  doctorId: string;
  registrationNumber: string;
  documents: { url: string; name: string }[];
  status: "PENDING" | "APPROVED" | "REJECTED";
  reason?: string;
  submittedAt: string;
}

export const submitDoctorVerification = (body: {
  registrationNumber: string;
  documents: { url: string; name: string }[];
}) => apiPost<DoctorVerification>("/api/auth/doctor/verify", body);

export const listMyVerifications = () =>
  apiGet<DoctorVerification[]>("/api/auth/doctor/verifications/mine");

export const listPendingVerifications = () =>
  apiGet<DoctorVerification[]>("/api/auth/doctor/verifications/pending");

export const decideVerification = (
  verificationId: string,
  body: { status: "APPROVED" | "REJECTED"; reason?: string },
) =>
  apiPatch<DoctorVerification>(
    `/api/auth/doctor/verify/${verificationId}`,
    body,
  );
